import { render } from "./tg-bot-algorithms.component.vue?vue&type=template&id=12ed2800"
import script from "./tg-bot-algorithms.component.vue?vue&type=script&lang=js"
export * from "./tg-bot-algorithms.component.vue?vue&type=script&lang=js"

import "./tg-bot-algorithms.component.vue?vue&type=style&index=0&id=12ed2800&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__